import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const urlSchema = Yup.string()
    .required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
    .test("is-url", "Ingrese una URL válida (ej. https://ejemplo.com)", (value) => {
        if (!value || !value.trim()) return false;
        try {
            const normalized = value.includes("://") ? value : `https://${value}`;
            new URL(normalized);
            return true;
        } catch {
            return false;
        }
    });

const LinkItemFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            fields: [
                [
                    {
                        type: "hidden",
                        name: "linkCategoryId",
                    },
                ],
                [
                    {
                        type: "text",
                        name: "title",
                        label: "Nombre del enlace",
                        isHorizontal: true,
                        labelSizing: { sm: 3 },
                        sizing: { sm: 9 },
                        validation: Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        type: "text",
                        name: "url",
                        label: "URL",
                        isHorizontal: true,
                        labelSizing: { sm: 3 },
                        sizing: { sm: 9 },
                        validation: urlSchema,
                    },
                ],
            ],
        },
    ],
};

export default LinkItemFormConfig;
